require('./helpers/bundle-manifest').register(new __parcel__URL__("").toString(),JSON.parse("[\"khzbE\",\"index.js\",\"kOm9U\",\"marker-icon.svg\"]"));